import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Button, Input, Select } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import Switchbox from '../../../../components/user/from/Switchbox'
import ViewDraftMeeting from '../../../../components/user/from/MeetingManagement/ViewDraftMeeting'
import ViewSuccessMeeting from '../../../../components/user/from/MeetingManagement/ViewSuccessMeeting'
import { UrlMeeting } from '../../../../utils/auth'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import axios from 'axios';
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";

const { Option } = Select;
const { Search } = Input;
const { TabPane } = Tabs;
const { Text, Title } = Typography

class CreateMeeting extends React.Component {

    state = {
        // backPage
        reqApprove: false,
        reqNote: false,
        dataMeeting: [],
        dataMeetingSuccess: []
    }

    componentDidMount = () => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingdraft`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingDate: "",
                // MeetingName: "",
                // limit: 10,
                // offset: 0
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                // console.log("searchMeetingdraft", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingevercreated`,
            {
                UserID: sessionStorage.getItem('username'),
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeetingSuccess: data ? data : [] })
                console.log("dataMeetingSuccess", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }

    onChangeType = (value) => {
        console.log("value", value);
    }
    changeApproveSwitch = async (e) => {
        await this.setState({
            reqApprove: e,
        })
    }
    changeNoteSwitch = async (e) => {
        await this.setState({
            reqNote: e,
        })
    }
    onChangeSearchDraft = (value) => {
        // console.log("value", value);
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingdraft`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingDate: "",
                MeetingName: value,
                // limit: 10,
                // offset: 0
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                console.log("searchMeetingdraft", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeSearchSuccessmeeting = (value) => {
        // console.log("value", value);
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingevercreated`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: value,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeetingSuccess: data ? data : [] })
                // console.log("dataMeetingSuccess", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )

    }
    render() {
        const { match } = this.props
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div className="card-container meeting-management" id="create-meeting">
                    <div className="p-5 card-bg-white">
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="สร้างการประชุมใหม่" key="1">
                                <div>
                                    <Switchbox
                                        onChange={this.changeApproveSwitch}
                                        label="การประชุมที่ต้องมีการขออนุมัติ"
                                        textToolTip={`เมื่อเลือกการประชุมประเภทที่ต้องมีการขออนุมัติ แล้วกด “ส่งขออนุมัติ“ ระบบจะส่งการประชุมนี้
                                        ให้ผู้ที่มีสิทธิอนุมัติ ทำการอนุมัติ หลังจากนั้นระบบ
                                        จึงจะส่งเชิญประชุมให้กับผู้ที่เชิญโดยอัตโนมัติ`} />
                                    <Switchbox
                                        onChange={this.changeNoteSwitch}
                                        label="การประชุมที่ต้องมีการส่งบันทึกและแสดงความเห็นชอบ"
                                        textToolTip={`เมื่อเลือกการประชุมประเภทที่ต้องส่งบันทึกและ
                                        แสดงความเห็นชอบ หลังจากผู้สร้างการประชุม
                                        ส่งบันทึกการประชุมระบบจะแจ้งเตือนให้ผู้ถูกเชิญ
                                        สามารถแสดงความเห็นชอบหรือความคิดเห็น
                                        การประชุมได้`} />
                                    <Row gutter={16} className={'py-4'}>
                                        <Col xs={{ span: 20, offset: 2 }} lg={{ span: 16, offset: 4 }} >
                                            <Link
                                                to={{
                                                    pathname: '/meetingmanagement/createMeetingForm/',
                                                    search: 'approve=' + (this.state.reqApprove ? "yes" : "no") + '&note=' + (this.state.reqNote ? "yes" : "no") + '&from=/meetingmanagement/CreateMeeting',
                                                }}>
                                                <Button className={'button-meeting-main'}>
                                                    สร้างการประชุม</Button>
                                            </Link>
                                            {/* <Link
                                                to={{
                                                    pathname: '/meetingmanagement/createMeetingFormWithApprove/',
                                                }}>
                                                <Button className={'button-meeting'}>
                                                    แบบขออนุมัติ</Button>
                                            </Link> */}
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane tab="การประชุมฉบับร่าง" key="2">
                                <div>
                                    <Row gutter={16} className={'py-4 mr-0 ml-0'}>
                                        <Col xs={24} lg={12}>
                                            <Search
                                                placeholder="ค้นหา"
                                                onSearch={value => this.onChangeSearchDraft(value)}
                                                style={{ width: '100%' }}
                                            />
                                        </Col>
                                        {/* <Col xs={24} lg={5} >
                                            <Button className={'button-meeting-search mt-3 mt-lg-0'}>
                                                ค้นหา</Button>
                                        </Col> */}
                                    </Row>
                                    <div style={{ height: 650, width: '100%', overflow: "auto" }}>
                                        <ViewDraftMeeting dataMeeting={this.state.dataMeeting}></ViewDraftMeeting>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tab="การประชุมที่เคยสร้าง" key="3">
                                <div>
                                    <Row gutter={16} className={'py-4 mr-0 ml-0'}>
                                        <Col xs={24} lg={12}>

                                            <Search
                                                placeholder="ค้นหา"
                                                onSearch={value => this.onChangeSearchSuccessmeeting(value)}
                                                style={{ width: '100%' }}
                                            />
                                        </Col>
                                        {/* <Col xs={24} md={12} lg={7} >
                                            <Select
                                                showSearch
                                                defaultValue="all"
                                                style={{ width: '100%' }}
                                                optionFilterProp="children"
                                                onChange={this.onChangeType}
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value="all" >ทั้งหมด</Option>
                                                <Option value="approver">มีผู้อนุมัติ</Option>
                                                <Option value="notapprover">ไม่มีผู้อนุมัติ</Option>
                                            </Select>
                                        </Col>
                                        <Col xs={24} md={12} lg={5} >
                                            <Button className={'button-meeting-search mt-3 mt-lg-0'}>
                                                ค้นหา</Button>
                                        </Col> */}
                                    </Row>
                                    <div style={{ height: 750, width: '100%', overflow: "auto" }}>
                                        <ViewSuccessMeeting dataMeeting={this.state.dataMeetingSuccess}></ViewSuccessMeeting>
                                    </div>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </Container >
        )
    }
}

CreateMeeting.propTypes = {
    //
}

export default withApollo(CreateMeeting)